import { Popconfirm, Space, Tooltip } from "antd";
import CommonButton from "commons/Buttons/CommonButton";
import RemoveButton from "commons/Buttons/RemoveButton";
import { FormatDate, FormatUnixDate } from "utils/helpers/date_helpers";
import { FaCircle, FaLock, FaUnlock } from 'react-icons/fa';
import Text from "antd/lib/typography/Text";
import ServiceLocations from "services/locations";
import { useState, useMemo } from "react";
import { CopyOutlined } from '@ant-design/icons';

export const AirTreeProjectTableColumns = (props) => {

    const editRecord = (record) => {
        props?.upsertRecord(record);
    };

    const deleteRecord = (record) => {
        props?.deleteRecord(record);
    };

    const viewRecord = (record) => {
        props?.viewRecord(record);
    };

    const cloneRecord = (record) => {
        props?.cloneRecord(record);
    };

    return [
        {
            title: 'Cod.',
            dataIndex: 'id',
            className: 'text-center',
            fixed: true,
            width: 100,
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            className: 'text-center',
            width: 100,
            filters: [
                { text: 'Pubblico', value: 1 },
                { text: 'Privato', value: 2 }
            ],
            render: (record) => {
                return record === 1 ? <Tooltip title="Progetto pubblico"><FaUnlock color="#52c41a" /></Tooltip> : <Tooltip title="Progetto privato"><FaLock color="#cf1322" /></Tooltip>
            }
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            sorter: true,
            search: true,
            width: '15%'
        },
        {
            title: 'Regione',
            dataIndex: 'regione.regione',
            key: 'id_region',
            sorter: true,
            search: true,
            filters: props?.regioni
        },
        {
            title: 'Inizio simulazione',
            dataIndex: 'simulation_date_start',
            sorter: true,
            search: 'date',
            render: (record) => {
                return FormatDate(record)
            }
        },
        {
            title: 'Fine simulazione',
            dataIndex: 'simulation_date_end',
            sorter: true,
            search: 'date',
            render: (record) => {
                return FormatDate(record)
            }
        },
        {
            title: 'Terreno',
            dataIndex: 'soil_texture_label',
            sorter: true,
            search: true,
            filters: [
                { text: 'Sabbioso', value: 1 },
                { text: 'Limoso', value: 2 },
                { text: 'Argilloso', value: 3 },
                { text: 'Altro', value: 99 }
            ],
        },
        {
            title: 'Creato il',
            dataIndex: 'created_at',
            sorter: true,
            search: 'date',
            render: (record) => {
                return FormatUnixDate(record)
            }
        },
        {
            title: 'User',
            dataIndex: 'createdBy.username',
            key: 'createdBy',
            sorter: true,
            search: true
        },
        {
            title: 'Stato',
            dataIndex: 'status',
            fixed: 'right',
            sorter: true,
            search: true,
            filters: [
                { text: 'Simulazione inviata', value: 1 },
                { text: 'Simulazione completata', value: 2 },
                { text: 'Elaborazione in corso', value: 0 },
            ],
            render: (record) => {
                let status;
                switch (record) {
                    case 1:
                        status = { icon: <FaCircle color="#fadb14" style={{ verticalAlign: 'middle' }} />, label: <Text type="secondary">Simulazione inviata</Text> }
                        break;
                    case 2:
                        status = { icon: <FaCircle color="#52c41a" style={{ verticalAlign: 'middle' }} />, label: <Text type="secondary">Simulazione completata</Text> }
                        break;
                    default:
                        status = { icon: <FaCircle color="#13c2c2" style={{ verticalAlign: 'middle' }} />, label: <Text type="secondary">Elaborazione in corso</Text> }
                        break;
                }
                return <>{status?.icon} {status?.label}</>
            }
        },
        {
            title: 'Azioni',
            key: 'action',
            width: '8%',
            fixed: 'right',
            className: 'actions',
            render: (record) => (
                <div className="text-center">
                    <Space>

                        {record?.status === 0 &&
                            <CommonButton
                                tooltip="Modifica progetto"
                                onClick={() => editRecord(record)}
                                icon="edit"
                                type="link"
                            />
                        }

                        <Popconfirm
                            title={'Verranno duplicati solo i dati e l\'area di progetto, procedere?'}
                            onConfirm={() => cloneRecord(record)}
                            //onCancel={onCancel}
                            okText="Si"
                            cancelText="No"
                        >
                            <CommonButton
                                tooltip="Duplica progetto"
                                icon="clone"
                                type="link"
                            />
                        </Popconfirm>

                        {record?.status === 2 &&
                            <CommonButton
                                tooltip="Visualizza dati simulazione"
                                onClick={() => viewRecord(record)}
                                icon="eye"
                                type="link"
                            />
                        }
                        {!props?.public && record?.status === 0 &&
                            <RemoveButton
                                tooltip="Elimina progetto"
                                confirmmessage="Rimuovere la scheda progetto selezionata?"
                                onConfirm={() => deleteRecord(record)}
                            />}

                    </Space>
                </div>
            ),
        },
    ]
};